// What startup asks the bootstrap endpoint for, on the netplay page and after
// a reconnect. The DM list's first page carries each conversation's unread
// flag, so loading it here gives the Chat header badge and the DMs tab badge
// their count without waiting for the DMs tab to open.

// Startup order; matches BootstrapSection on the server.
export const BOOTSTRAP_SECTIONS = [
	'my_user',
	'my_ladders',
	'counts',
	'site_notification',
	'notifications',
	'locked_searches',
	'chat_text',
	'private_chats',
	'current_match',
	'chat_rooms',
	'chat_messages',
];

const CHAT_ROOM_SECTIONS = ['chat_rooms', 'chat_messages'];

export function bootstrapFields({ netplayPage, matchOnlyMode, isReconnect, loadPrivateChats }) {
	// Other pages get the user, the header's notification bell, and the
	// current match and room list the dock shows (react/dock). A room's
	// messages, emotes, the player's ladders and the DM list load when the
	// dock's sheet opens.
	if(!netplayPage) {
		return ['my_user', 'notifications', 'current_match', 'chat_rooms'];
	}
	return BOOTSTRAP_SECTIONS.filter((name) => {
		if(matchOnlyMode && CHAT_ROOM_SECTIONS.includes(name)) {
			return false;
		}
		// Emotes and chat links don't change during a session.
		if(isReconnect && name === 'chat_text') {
			return false;
		}
		if(!loadPrivateChats && name === 'private_chats') {
			return false;
		}
		return true;
	});
}

// Only the first page: a reconnect must not page further through the list
// (new messages arrive over the socket).
export function shouldLoadPrivateChatsAtStartup({ lastLoadedPrivateChatPage, loadedAllOpenPrivateChats }) {
	return !loadedAllOpenPrivateChats && !lastLoadedPrivateChatPage;
}
